import React, { Component } from 'react';
import {  Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import adminTip from '../../img/tips_blank.png';
import homeTip from '../../img/home.1.png';
// import awayTip from '../../img/away.png';

interface TeamInfo {
  teamLogo?: string;
  teamname?: string;
}

interface TippingDataItem {
  _id: string;
  count: number;
}

interface GameDetail {
  homeTeam: TeamInfo;
  awayTeam: TeamInfo;
  tippingData: TippingDataItem[];
}

interface TipdistributionProps {
  data: {
    usercount?: number;
    gameDetailAndTipping?: GameDetail[];
  };
  sportId: string | null;
  handeTippingCount: (sportId: string | null, limit: number) => void;
}

interface TipdistributionState {
  dropdownOpen: boolean;
  selectedUserGroup: string;
  limit: number;
}

class Tipdistribution extends Component<TipdistributionProps, TipdistributionState> {
  constructor(props: TipdistributionProps) {
    super(props);
    this.state = {
      dropdownOpen: false,
      selectedUserGroup: 'top 10',
      limit: 10,
    };
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  handleUserGroupSelection = (limit: number) => {
    this.props.handeTippingCount(this.props.sportId, limit);
    this.setState({
      limit,
    });
  };

  render() {
    const { data } = this.props;
    const limitData = [10, 20, 50, 100, 200, 300, 500];
    return (
      <>
        <div className="tipdistribution">
          <h2 className="page-heading">Tip Distribution</h2>
          <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
            <DropdownToggle caret>
              User Group:Top {this.state.limit}
            </DropdownToggle>
            <DropdownMenu>
              {limitData.map((num) => {
                return (
                  <DropdownItem key={num} onClick={() => this.handleUserGroupSelection(num)}>
                    top {num}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
            <i className="fa fa-sort-amount-asc" aria-hidden="true"></i>
          </Dropdown>
        </div>
        {data && (data?.gameDetailAndTipping?.length ?? 0) > 0
          ? data.gameDetailAndTipping!.map((game, index) => {
              const ImagePath = (url: string) => {
                if (url !== '') {
                  return url;
                }
                return homeTip;
              };
              const tiippingCount = (team: string) => {
                const filtered = game?.tippingData.filter((ele) => ele._id === team);
                return filtered[0] ? filtered[0].count : 0;
              };
              const addTiiping = tiippingCount('home') + tiippingCount('away');
              return (
                <div key={index}>
                  <h5>
                    {game?.homeTeam.teamname + ' VS ' + game?.awayTeam.teamname}
                  </h5>
                  <div className="tip_container">
                    <div className="tip_inner">
                      <p>HOME</p>
                      <img src={ImagePath(game?.homeTeam.teamLogo || '')} alt="Home team logo" />
                      <p>{tiippingCount('home') || 0} Tips</p>
                    </div>
                    <div className="tip_inner">
                      <p>AWAY</p>
                      <img src={ImagePath(game?.awayTeam.teamLogo || '')} alt="Away team logo" />
                      <p>{tiippingCount('away') || 0} Tips</p>
                    </div>
                    <div className="tip_inner">
                      <p>NO TIP</p>
                      <img src={adminTip} alt="No tip icon" />
                      <p>{(data.usercount || 0) - addTiiping || 0} Tips</p>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </>
    );
  }
}

export default Tipdistribution;












